// extracted by mini-css-extract-plugin
export var wfLatoLoaded = "ExpenseDetails-module--wf-Lato--loaded--2UcXw";
export var h5 = "ExpenseDetails-module--h5--69MOv";
export var h6 = "ExpenseDetails-module--h6--1OBfM";
export var table = "ExpenseDetails-module--table--fQD9t";
export var container = "ExpenseDetails-module--container--2QJEe";
export var fadeIn = "ExpenseDetails-module--fadeIn--1JvLs";
export var moveLeft = "ExpenseDetails-module--moveLeft--2Gbbp";
export var moveDown = "ExpenseDetails-module--moveDown--2Eyam";
export var illuMoveDown = "ExpenseDetails-module--illuMoveDown--nHrUH";